import { Branding, BrandingImage, Link } from "@bcm-dev/bcms-vite";
import React from 'react';
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function PageHeader
 * @return {React.Component}
 * @exported true
 * @description this is the page header that goes at the top of every single page.
 * @example
 * <PageHeader />
 */
export default function PageHeader(props) {
  return (
    <div className="page-header flex-container flex-horizontal main-span-all-col">
      <div className="align-center-item  flex-width">
        <BrandingImage id="standalone_fi_logo_chw23" className="institution-logo" alt="Financial Institution Logo" />
      </div>

      <Branding id="nonfiserv_olb_chw23" value="false" default="false">
        <Link to="/settings" className="align-center-item set-width" dataPoint="Settings_Link">
          <SVGAsset id="GearIcon" className="icon" />
        </Link>
      </Branding>
    </div>
  );
}